(function () {
  if (window.__ptEng) return; window.__ptEng = 1;
  function emit(n, p) { try { if (window.traxEmit) window.traxEmit(n, p); } catch (e) {} }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('[data-pt]');
    if (!a) return;
    var c = a.closest('.pt-er,.pt-ean');
    if (!c) return;
    var href = a.getAttribute('href') || '';
    if (/^(sms|tel):/i.test(href)) return;
    var ph = c.getAttribute('data-ph') || '';
    emit('select_promotion', { promotion_id: 'engagement-' + a.getAttribute('data-pt'), promotion_name: ph + '|' + (a.getAttribute('data-pn') || ''),
      creative_slot: ph, link_url: href || location.pathname });
  }, true);
  var b = document.querySelector('.pt-er');
  if (b && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) {
      for (var i = 0; i < es.length; i++) if (es[i].isIntersecting) {
        var ph = b.getAttribute('data-ph') || '';
        emit('view_promotion', { promotion_id: 'engagement-view', promotion_name: ph + '|row', creative_slot: ph, link_url: location.pathname });
        io.disconnect(); break;
      }
    }, { threshold: 0.25 });
    io.observe(b);
  }
})();
